<template>
    <div id="mainPage">
      <div id="scollPoint" v-if="!$root.isMob">
        <div class="point" v-for="(item,key) in pageList" :key="item" @click="scrollTo(item)">
          <div class=text>{{ pageListTitle[key] }}</div>
        </div>
      </div>
      <div id="p0" style="width: 100%;">
        <BannerIMG :bannerArray="banners"/>
      </div>      
      <div id="p1" class="lightBG" :style="{background:'url('+newsBg+')'}">
        <div class="contentBox leftToRight">
          <div class="textZh">公司介绍</div>
          <div class="diagonal-line"></div>
          <div class="textEn">Company Intro</div> 
        </div>
        <div class="contentBox mainContent companyContent1">
          <div class="companyIntro" v-html="companyIntro"></div>
          <div class="companyIntroImg"  v-if="companyIntroImg">
            <img :src="baseUrl+companyIntroImg"/>
          </div>
        </div>
        <div class="contentBox mainContent companyContent2">
          <div v-html="serviceIntro"></div>
        </div>    
        <!-- <div class="contentBox leftToRight">
          <div class="textZh">团队介绍</div>
          <div class="diagonal-line"></div>
          <div class="textEn">TEAM INTRODUCTION</div> 
        </div>     -->
        <div class="contentBox mainContent companyContent3">
          <div v-html="teamIntro"></div>
        </div>    
      </div>
      <div id="p2" class="darkBG equipmentBg" :style="{background:'url('+cooperbgM+')'}">
        <div class="contentBox leftToRight">
          <div class="textZh">软件著作权</div>
          <div class="diagonal-line"></div>
          <div class="textEn">SOFTWARE COPYRIGHT</div> 
        </div>
        <div class="contentBox mainContent softwareContent">
          <div class="copyright-stack">
            <img  v-for="(item,index) in softwareContent" :key="index"  :src="baseUrl+item" :preview-src-list="softwareContent" />
          </div>          
        </div>
      </div>
      <div id="p3" class="lightBG franchise" :style="{background:'url('+softWareBg+')'}">
        <div class="contentBox leftToRight">
          <div class="textZh">虚拟软件专营开发</div>
          <div class="diagonal-line"></div>
          <div class="textEn">Virtual software exclusive development</div> 
        </div>
        <div class="contentBox mainContent franchiseContent">
            <div class="franchiseItem" v-for="item in franchiseContent" :key="item.id">
              <div class="text">{{ item.title }}</div>
              <div class="imgBox">                  
                <img :src="item.img" />
              </div>
            </div>
        </div>
      </div>
      <!-- <div id="p4" class="lightBG nanoBg" :style="{background:'url('+newsBg+')'}">
        <div class="contentBox leftToRight">
          <div class="textZh">纳米微观虚拟实验室</div>
          <div class="diagonal-line"></div>
          <div class="textEn">NANO MICRO VIRTUAL LABORATORY</div>        
        </div>
        <div class="contentBox mainContent nanoContent">
          <div class="nanoBox">
            <div class="row">
              <div class="col nano1" @click="linkTo('/nano?goto=p0',false,true)" @mouseenter="nanoAnimation('nano1',true)" @mouseleave="nanoAnimation('nano1',false)">
                <div class="title">NO.1 产品中心</div>
                <div class="nanoImg" :style="{background:'url('+productCenterMini+')'}"></div>
              </div>
              <div class="col nano2" @click="linkTo('/nano?goto=p1',false,true)" @mouseenter="nanoAnimation('nano2',true)" @mouseleave="nanoAnimation('nano2',false)">
                <div class="title2">NO.2 产品演示</div>
                <div class="nanoImg" :style="{background:'url('+productDemoMini+')'}"></div>
              </div>
            </div>
            <div class="row">
              <div class="col nano3" @click="linkTo('/nano?goto=p2',false,true)" @mouseenter="nanoAnimation('nano3',true)" @mouseleave="nanoAnimation('nano3',false)">
                <div class="title">NO.3 解决方案</div>
                <div class="nanoImg" :style="{background:'url('+caseMini+')'}"></div>
              </div>
              <div class="col nano4" @click="linkTo('/nano?goto=p3',false,true)" @mouseenter="nanoAnimation('nano4',true)" @mouseleave="nanoAnimation('nano4',false)">
                <div class="title2">NO.4 客户案例</div>
                <div class="nanoImg" :style="{background:'url('+case2Mini+')'}"></div>
              </div>
            </div>
          </div>
        </div>
        <svg class="circleSvg"></svg>
        <div class="nanoBgImg">
          <div class="animationBox">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
          <img v-if="$root.isMob" :src="nanoBgPC"/>
          <img v-if="!$root.isMob" :src="nanoBg"/>
        </div>
      </div> -->
      <div id="p4" class="darkBG equipmentBg" :style="{background:'url('+equipmentBg+')'}">        
        <div class="contentBox leftToRight">
          <div class="alert">
            <span ref="alertText">滑动滚轮试试</span>
            <i class="el-icon-position icon"></i>
          </div>
          <div class="textZh">设备专营设备销售</div>
          <div class="diagonal-line"></div>
          <div class="textEn">EQUIPMENT SALES</div>
        </div>    
        <div class="contentBox mainContent">
          <!-- <div class="equipmentTitle">
            <span>设备主要用途</span>              
          </div>   
          <div class="equipmentFooter">
            VIRTUAL<br>
            ELECTRON<br>
            MICROSCOPE<br>
            MUSEUM<br>
          </div>         -->
          <div class="equipmentContent" ref="equipmentContent" @mouseover="isScrolling=true" @mouseleave="isScrolling=false">
            <div class="equipmentItems" v-for="item in categoryList" :key="item.id" @click="linkTo(item.id,true)">
              <div class="imgBox">                  
                <img :src="baseUrl+item.image"/>
              </div>              
              <div class="equipmentItemText">
                <div class="equipmentItemIcon">
                  <i class="el-icon-caret-right"></i>
                </div>
                <div class="text">
                  {{item.title}}
                </div>                
              </div>
            </div>            
          </div> 

          <div class="equipmentCateMob">
            <div class="equipmentItems" v-for="item in categoryList" :key="item.id" @click="linkTo(item.id,true)" :style="{background:'url('+newsBg+')'}">
              <div class="imgBox">
                <img :src="baseUrl+item.image"/>
              </div>
              <div class="text">
                {{item.title}}
              </div>
            </div>
          </div>
        </div>  
      </div>
      <div class="lightBG newsBg aboutUs" :style="{background:'url('+newsBg+')'}">
        <div class="contentBox leftToRight">        
          <div class="textZh">公司介绍</div>
          <div class="diagonal-line"></div>
          <div class="textEn">COMPANY INTRODUCTION</div>
        </div>   
        <div class="contentBox mainContent" v-html="companyIntro">
          <!-- <div class="companyIntroImg"  v-if="companyIntroImg">
            <img :src="baseUrl+companyIntroImg"/>
          </div> -->
        </div>
        
        <!-- <div class="contentBox leftToRight paddingTop50">        
          <div class="textZh">主营业务</div>
          <div class="diagonal-line"></div>
          <div class="textEn">MAIN SERVICE</div>
        </div>    -->
        <div class="contentBox mainContent" v-html="serviceIntro"></div>
      </div>
      <div class="darkBG equipmentBg productListMob" :style="{background:'url('+projectBg+')'}">
        <div class="contentBox leftToRight">        
          <div class="textZh">主营产品</div>
          <div class="diagonal-line"></div>
          <div class="textEn">Main Products</div>          
        </div>  
        <div class="productListBox">
          <ProductList :data="productDataList"/>
        </div>
        <div class="productsListButtonMob">
          <RouterLink to="/productsList" class="button">查看更多</RouterLink>          
        </div>
      </div>          
      <div id="p5" class="lightBG newsBg" :style="{background:'url('+newsBg+')'}">
        <div class="contentBox leftToRight">        
          <div class="textZh">新闻动态</div>
          <div class="diagonal-line"></div>
          <div class="textEn">NEWS INFORMATION</div>          
        </div>
        <div class="contentBox mainContent">
          <Newslist :isHome="true" :newsList="newsDataList" @itemClick="newsClick"/>
          <div class="newsListButton">
            <RouterLink to="/news" class="button">查看更多</RouterLink>          
          </div>
        </div>
        <div class="newsListButtonMob contentBox">
          <RouterLink to="/news" class="button">查看更多</RouterLink>          
        </div>
      </div>      
      <div class="darkBG newsBg aboutUs" :style="{background:'url('+contectUsM+')'}">
        <div class="contentBox leftToRight">        
          <div class="textZh">联系我们</div>
          <div class="diagonal-line"></div>
          <div class="textEn">CONTACT US</div>
        </div>  
        <div class="contentBox mainContent">
          <div class="baiduMapBox">
            <div class="map-container" @wheel="handleMapWheel">
              <img :src="mapImage" class="map-image" :style="{transform: `scale(${mapScale})`}"/>
            </div>
          </div>          
          <div class="aboutUsCard">
              <div class="item">
                  <div class="icon">
                      <img :src="i1"/>
                  </div>
                  <div>
                      <a href="tel:15101614752">郭经理:15101614752</a><br>
                      <a href="tel:15101614752">刘经理:15837840771</a>
                  </div>
              </div>
              <div class="item">
                  <div class="icon">
                      <img :src="i2"/>
                  </div>
                  <div>
                      <a href="mailto:feitem316@163.com">feitem316@163.com</a>
                  </div>
              </div>
              <div class="item">
                  <div class="icon">
                      <img :src="i3"/>
                  </div>
                  <div>
                      河南省开封市龙亭区郑开大道与八大街交界三合国际4楼
                  </div>
              </div>
          </div>
        </div>
      </div>
      <div class="lightBG cooperList cooperBg coopersMob" :style="{background:'url('+newsBg+')'}">
        <div class="contentBox leftToRight">
          <div class="textZh">合作伙伴</div>
          <div class="diagonal-line"></div>
          <div class="textEn">COOPERATIVE PARTNER</div>     
        </div>      
        <div class="contentBox mainContent cooperList">
          <div class="coopers" v-for="item in coopers" :key="item.id" @click="linkTo(item.url)">
            <img :src="baseUrl+item.logo"/>
            <!-- <span>
              {{ item.title }}
            </span> -->
          </div>
        </div>
      </div>  
      <div id="p6" class="darkBG cooperList cooperBg" :style="{background:'url('+cooperBg+')'}">
        <div class="contentBox leftToRight">
          <div class="textZh">合作伙伴</div>
          <div class="diagonal-line"></div>
          <div class="textEn">COOPERATIVE PARTNER</div>     
        </div>      
        <div class="contentBox mainContent cooperList">
          <div class="coopers" v-for="item in coopers" :key="item.id" @click="linkTo(item.url)">
            <img :src="baseUrl+item.logo"/>
            <span>
              {{ item.title }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Newslist from '@/components/NewsList.vue'
  import BannerIMG from '@/components/BannerIMG.vue';
  import ProductList from '@/components/ProductList.vue';

  //静态资源导入S
  import productCenterMini from '@/assets/img/productCenterMini.jpg';
  import productDemoMini from '@/assets/img/productDemoMini.jpg';
  import caseMini from '@/assets/img/caseMini.jpg';
  import case2Mini from '@/assets/img/case2Mini.jpg'
  import nanoBg from '@/assets/img/nanoBg.png';
  import nanoBgPC from '@/assets/img/nanoBgPC.png';
  import equipmentBg from '@/assets/img/equipmentBg.jpg';
  import newsBg from '@/assets/img/newsBg.jpg';
  import cooperBg from '@/assets/img/cooperBg.jpg';
  import contectUsM from '@/assets/img/contectUsM.png';
  import projectBg from '@/assets/img/projectBg.jpg';
  import cooperbgM from '@/assets/img/cooperbg-m.jpg';
  import i1 from '@/assets/img/i1w.png';
  import i2 from '@/assets/img/i2w.png';
  import i3 from '@/assets/img/i3w.png';
  import mapImage from 'd:/guanwang/image.png';
  import soft1 from '@/assets/img/soft1.png';
  import soft2 from '@/assets/img/soft2.png';
  import soft3 from '@/assets/img/soft3.png';
  import soft4 from '@/assets/img/soft4.png';
  import softWareBg from '@/assets/img/softWare.jpg';
  //静态资源导入E
  
  export default {
    name: 'mainPage',
    components: {
      Newslist,
      ProductList,
      BannerIMG
    },
    data() {
      return {
        //静态资源声明S
        productCenterMini:productCenterMini,
        productDemoMini:productDemoMini,
        caseMini:caseMini,
        case2Mini:case2Mini,
        nanoBg:nanoBg,
        nanoBgPC:nanoBgPC,
        equipmentBg:equipmentBg,
        newsBg:newsBg,
        cooperBg:cooperBg,
        contectUsM:contectUsM,
        projectBg:projectBg,
        cooperbgM:cooperbgM,
        i1:i1,
        i2:i2,
        i3:i3,
        //静态资源声明E
        //地图图片缩放数据S
        mapScale: 1,
        mapImage: mapImage,
        //地图图片缩放数据E
        baseUrl:window.config.apiUrl,
        coopers:[],
        banners:[],
        newsDataList:[],
        categoryList:[],
        pageList:['p0','p1','p2','p3','p4','p5','p6'],
        pageListTitle:['轮播图','公司介绍','软件著作权','虚拟软件专营开发','实验设备','新闻动态','合作伙伴'],
        productDataList:[],
        currentPage:'p0',
        wheelEvent:null,
        isScrolling:false,
        companyIntro:'',
        companyIntroImg:'',
        serviceIntro:'',
        teamIntro:'',
        softwareContent:[],
        franchiseContent:[{
          id:1,
          title:'No.1 数智WEB',
          img:soft1,
          url:soft1,
        },
        {
          id:2,
          title:'NO.2 数智VR',
          img:soft2,
          url:soft2,
        },
        {
          id:3,
          title:'NO.3 云课堂',
          img:soft3,
          url:soft3,
        },
        {
          id:4,
          title:'NO.4 3D模型',
          img:soft4,
          url:soft4,
        }],
        softWareBg:softWareBg,
      }
    },
    
    watch: {
      // "isScrolling":function(){
      //   if(this.isScrolling == true && this.categoryList.length > 2){
      //     this.$notify.info("已开启横向滚动");
      //     this.$refs.equipmentContent.classList.add('equipmentActive');
      //   }
      //   else{
      //     this.$notify.info("已恢复默认滚动");
      //     this.$refs.equipmentContent.classList.remove('equipmentActive');
      //   }
      // },
    },
    methods: {
      handleMapWheel(event) {
          event.preventDefault();
          const scaleStep = 0.1;
          if (event.deltaY < 0) {
              this.mapScale = Math.min(this.mapScale + scaleStep, 3);
          } else {
              this.mapScale = Math.max(this.mapScale - scaleStep, 0.5);
          }
      },
      newsClick(item){
        this.linkTo('/newsDetail?id='+item,false,false)
      },
      async getBaseData() {
        try {
          this.categoryList = await this.$root.getCategoryData();
          // console.log(this.categoryList,'categoryList');
          let info = await this.$root.getLinks(1);
          this.coopers = info.data;
          info = await this.$root.getBanner(1);
          this.banners = info.data;
          info = await this.$root.getNewsList("",3,"");
          
          //处理日期
          info.data.data.forEach(element => {
            let timestamp = element.updatetime;
            //转换时间戳为YYYY-MM-DD格式
            let date = new Date(timestamp*1000).toLocaleDateString();
            let dateArr = date.split("/");
            element.year = dateArr[0];
            element.mounth = dateArr[1];
            element.day = dateArr[2];
          });
          this.newsDataList = info.data.data;

          info = await this.$root.getCompanyInfo();
          this.companyIntro = info.data[0].content;
          this.companyIntroImg = info.data[0].images;
          this.softwareContent = info.data[1].images.split(",");
          // console.log(info.data[1].images);
          // console.log(this.softWareBg)
          
          
          // console.log(this.companyIntroImg);
          // this.teamIntro = info.data[1].content;
          // this.serviceIntro = info.data[2].content;
          // let softwarImg = info.data[3].images.split(",");
          // console.log(info.data[3].images.split(","));
          
          // this.softwareContent = softwarImg.map(item=>{
          //   return this.baseUrl+item;
          // });
          info = await this.$root.getProductListData(1,0,1);      
          // this.productDataList = info[0];
          
          this.getNewsData();
          this.equipmentWheel(); 
          this.fixCoopersHeight();
        
          this.$root.loadingClose();
          
        } catch (error) {
          this.error = '获取数据失败：' + error.message;
          console.log(this.error);
        }
      },
      getNewsData() {
        //处理日期
        this.newsDataList.forEach(element => {
          let timestamp = element.updatetime;
          //转换时间戳为YYYY-MM-DD格式
          let date = new Date(timestamp*1000).toLocaleDateString();
          let dateArr = date.split("/");
          element.year = dateArr[0];
          element.mounth = dateArr[1];
          element.day = dateArr[2];
        });
      },
      linkTo(url,isProductsList=false,isSelf=false){
        if(url == ""){
          return
        }
        if(url[0] == '/'){
            url = '/#'+url;
        }
        let target = "_blank";
        if(isSelf){
          target = "_self";
        }
        if(isProductsList){
          window.open('/#/productsList?category='+url,target);
        }
        else{
          window.open(url,target);
        }        
      },
      scrollTo(item){
        let targetPosition = document.getElementById(item).offsetTop - 78.67;
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'        // 平滑滚动
        });
        this.currentPage = item;
        let index = this.pageList.indexOf(this.currentPage);

        let scollPoint = document.getElementById('scollPoint');
        let point = scollPoint.querySelectorAll('.point');
        point.forEach(element => {
          element.classList.remove('active');
        });
        if(scollPoint){
          point[index].classList.add('active');
        }
      },
      equipmentWheel() {
        if(this.categoryList.length < 2){
          this.$refs.alertText.parentNode.style.opacity = 0;
        }
        else{
          this.$refs.alertText.parentNode.style.opacity = 1;
        }

        // 添加鼠标滚轮事件监听
        const equipmentContent = this.$el.querySelector('.equipmentContent');
        const equipmentItems = this.$el.querySelectorAll('.equipmentItems');

        //平滑滚动
        if(equipmentContent){
          equipmentContent.addEventListener('wheel', (event) => {            
            if(this.categoryList.length < 2){
              this.isScrolling = false;
              return;
            }
            this.isScrolling = true;
            this.$refs.alertText.parentNode.style.opacity = 0;
            event.preventDefault();
            const scrollAmount = event.deltaY *1.5; // 计算滚动的量

            // 使用 requestAnimationFrame 实现平滑滚动
            const start = equipmentContent.scrollLeft;
            const end = start + scrollAmount;
            const duration = 200; // 滚动持续时间
            const startTime = performance.now();

            const animateScroll = (currentTime) => {
              const timeElapsed = currentTime - startTime;
              const progress = Math.min(timeElapsed / duration, 1);
              equipmentContent.scrollLeft = start + (end - start) * progress;

              if (progress < 1) {
                requestAnimationFrame(animateScroll);
              }
            };

            requestAnimationFrame(animateScroll);
          })  
        }      
  
        // 监听最后一个和第一个元素的鼠标悬停事件
        const lastItem = equipmentItems[equipmentItems.length - 1];
        const firstItem = equipmentItems[0];
        // 当鼠标悬停在第一个元素上时，自动滚动到容器的最左侧
        if(firstItem){
          firstItem.addEventListener('mouseenter', () => {       
            setTimeout(() => {
              // 使用scrollTo来实现平滑滚动到最左侧
              equipmentContent.scrollTo({
                left: 0, // 滚动到容器的最左侧
                behavior: 'smooth' // 平滑滚动
              });
            }, 300);        
          });
        }
        
        // 当鼠标悬停在最后一个元素上时，自动滚动到容器的最右侧
        if(lastItem){
          lastItem.addEventListener('mouseenter', () => {       
            setTimeout(() => {
              const maxScrollLeft = equipmentContent.scrollWidth - equipmentContent.clientWidth;
    
              // 使用scrollTo来实现平滑滚动
              equipmentContent.scrollTo({
                left: maxScrollLeft,
                behavior: 'smooth' // 平滑滚动到容器的最右侧
              });
            }, 300);        
          });
        }
      },
      wheelListen() {
        let scollPoint = document.getElementById('scollPoint');
        let point = scollPoint.querySelectorAll('.point');
        if(scollPoint){
          point[0].classList.add('active');
        }
          // 添加鼠标滚轮事件监听
          this.wheelEvent = (event) => {
            event.preventDefault(); // 阻止默认的滚动行为

            if(!this.isScrolling){
              //this.isScrolling = true;              

              //计算currentPage在pageList中的位置
              let index = this.pageList.indexOf(this.currentPage);
              var targetPosition = 0;
              let scollPoint = document.getElementById('scollPoint');
              let point = scollPoint.querySelectorAll('.point');

              if (event.deltaY > 0) {                  
                  let target = this.pageList[index+1];                  
                  if(target != undefined){
                    targetPosition = document.getElementById(target).offsetTop - 78.67;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'        // 平滑滚动
                    });
                    this.currentPage = target;
                    
                    point.forEach(element => {
                      element.classList.remove('active');
                    });
                    if(scollPoint){
                      point[index+1].classList.add('active');
                    }
                  }                 
              }
              else {
                let target = this.pageList[index-1];
                if(target != undefined){
                  targetPosition = document.getElementById(target).offsetTop - 78.67;
                  window.scrollTo({
                      top: targetPosition,
                      behavior: 'smooth'        // 平滑滚动
                  });
                  this.currentPage = target;
                  
                  point.forEach(element => {
                    element.classList.remove('active');
                  });
                  if(scollPoint){
                    point[index-1].classList.add('active');
                  }
                }
              }

              let lastScrollY = window.scrollY;
              let scrollTimeout = setTimeout(() => {
                // 如果滚动时间到达后仍然没有滚动，认为滚动完成
                // if (Math.abs(lastScrollY - window.scrollY) < 5) {
                //   this.isScrolling = false;
                // }
              }, 150);

              // 监听滚动事件来判断是否发生了滚动
              let checkScroll = () => {
                if (Math.abs(lastScrollY - window.scrollY) >= 5) {
                  lastScrollY = window.scrollY; // 更新滚动位置
                  clearTimeout(scrollTimeout);  // 清除之前的超时计时器
                  scrollTimeout = setTimeout(() => {
                    if (Math.abs(lastScrollY - window.scrollY) < 5) {
                      //this.isScrolling = false;
                      window.removeEventListener('scroll', checkScroll); // 滚动完成后移除监听
                    }
                  }, 200);  // 重新开始计时1秒
                }
              };

              window.addEventListener('scroll', checkScroll);
            }
          }, { passive: false };
          
          window.addEventListener('wheel', this.wheelEvent, { passive: false });
      },
      fixCoopersHeight(){
        let cooperList = document.getElementsByClassName('cooperList')[0];
        let p4 = document.getElementById('p4');
        if(cooperList && p4){
          let height = cooperList.offsetHeight;
          p4.style.height = height - 100 + 'px';
        }
      },
      nanoAnimation(name,isActive){
        let list = ['nano1','nano2','nano3','nano4'];
        let nano = document.getElementsByClassName(name)[0];

        if(isActive){
          nano.classList.add('active');
        }
        else{
          nano.classList.remove('active');
        }
        
        list.forEach(item=>{
          if(item != name){
            let otherNano = document.getElementsByClassName(item)[0];
            if(isActive){
              otherNano.classList.add('noActive');
            }       
            else{
              otherNano.classList.remove('noActive');
            }     
          }
        })
      },
      nanoAnimation2(){
        const circles = document.querySelectorAll('.circle');
        const svg = document.querySelector('.circleSvg');
        const animationBox = document.querySelector('.animationBox');
        const updateLines = () => {
          if(this.currentPage != "p3"){
            animationBox.classList.add('hide');
            svg.classList.add('hide');
            return;
          }
          else{
            setTimeout(() => {
              animationBox.classList.remove('hide');            
              svg.classList.remove('hide');
            }, 400);            
          }
          svg.innerHTML = ''; // 清空已有线条
          for (let i = 0; i < circles.length - 1; i++) {
            const rect1 = circles[i].getBoundingClientRect();
            const rect2 = circles[i + 1].getBoundingClientRect();

            // 获取圆心位置
            const x1 = rect1.left + rect1.width / 2;
            const y1 = rect1.top + rect1.height / 2 - 79;
            const x2 = rect2.left + rect2.width / 2;
            const y2 = rect2.top + rect2.height / 2 - 79;

            // 创建连线
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('x1', x1);
            line.setAttribute('y1', y1);
            line.setAttribute('x2', x2);
            line.setAttribute('y2', y2);
            svg.appendChild(line);
          }
        }
        setInterval(() => {
          requestAnimationFrame(updateLines); 
        }, 5);
        
      },
    },
    mounted() {
      this.getBaseData();   
      if(!this.$root.isMob){
        this.wheelListen();   
        document.getElementsByTagName('body')[0].style.overflowY = 'hidden';      
      }   
      // this.nanoAnimation2();
    },
    destroyed() {
      //清理监听
      window.removeEventListener('wheel', this.wheelEvent);
      document.getElementsByTagName('body')[0].style.overflowY = 'auto';  
    }
  }
  </script>
  
  <style scoped>
    #p1{
      .companyContent1{
        display: flex;
        justify-content: space-between;
        .companyIntro{
          width: 59%;
          font-size: 16px;
          line-height: 16px;
        }
        .companyIntroImg{
          padding-top: 20px;
          width: 38%;
          img{
            width: 100%;
          }
        }
      }
    }
    #p2{
      .softwareContent{
        display:flex;
        justify-content:center;
        padding:40px 0;
      }
      /deep/ .copyright-stack{
        /* display:flex; */
        justify-content:center;
        /* 不靠padding占位，改用子元素错位 */
        position:relative;
        margin-top: 50px;
      }
      /deep/ .copyright-stack > img{
        /* 固定图片宽高，图片尺寸永久不变 */
        width:470px;
        height:640px;
        object-fit: contain;
        background: #fff;
        padding: 8px;
        border: 1px solid #eee;
        /* 只控制重叠：负值越大叠得越多 */
        margin-left:-336px;
        position:relative;
        z-index:1;
        transition:0.3s ease;
      }
      /deep/ .copyright-stack > img:first-child{
        margin-left:0;
      }
      /deep/ .copyright-stack > img:not(:first-child){
        z-index:2;
      }
    }
    #p3{
      background-size: 100%!important;
      background-position: right !important;
      background-repeat: no-repeat !important;
      .franchiseContent{
        display:flex;
        .franchiseItem{
          color: #f5f5f5;
          margin: 0 10px;
          box-sizing: border-box;
          overflow: hidden;
          width: 18%;
          height: 540px;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
          cursor: pointer;
          .text{
            width: 100%;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            font-weight: bold;
            color: #356a12;
            padding-left:10px;
          }
          .imgBox{
            width: 100%;
            overflow: hidden;
            img{
              width: 100%;
              transition: transform 0.3s ease;
              will-change: transform; /* 提前告知浏览器预备动画，无延迟 */
            }
            img:hover{
            transform: scale(1.1);
          }
          }
          
        }
      }
    }
  </style>
